import { Component, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { MenuItem, MessageService } from "primeng/api";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { ComuneDTO } from "src/app/models/comune.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { Impresa } from "src/app/models/impresa.model";
import { ModificaPraticaDTO } from "src/app/models/modificaPratica.scuola.model";
import { Pratica } from "src/app/models/pratica.model";
import { PraticaScuola } from "src/app/models/pratica.scuola.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ScuolaDTO } from "src/app/models/scuola.model";
import { ComuniService } from "src/app/services/comuni.service";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { ImpreseService } from "src/app/services/imprese.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";
import { DialogModificaPosizioneBando1 } from "../../../scuola/bando1/pratiche-scuola-bando1.component";
import { PosizioneScuola } from "../posizione-scuola/posizione-scuola.component";
import { ModificaPosizioneScuola } from "../modifica-posizione-scuola/modifica-posizione-scuola.component";
import { CentraliService } from "src/app/services/centrali.service";
import { Centrale } from "src/app/models/centrale.models";

@Component({
  selector: "component-modifica-codice-invio",
  templateUrl: "./dialog-modifica_codice_invio.component.html",
  styleUrls: ["../shared.component.css"],
})
export class ModificaCodiceinvio implements OnInit {
  protected _onDestroy = new Subject<void>();
  public pratica: Pratica;
  public praticaFromFirestore: PraticaFlowdy2_Firestore;

  protected codiceInvioForm: FormGroup;

 
  protected ref: DynamicDialogRef;

  private collection_pratiche_scuola: string = environment.firebase.collection_pratiche;

  protected comuni: ComuneDTO[] = [];


  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _formBuilder: FormBuilder,
    private praticheScuolaService: PraticheService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private firestoreService: AngularFirestore,
    private comuniService: ComuniService,
    private aziendeService: ImpreseService,
    private centraliService: CentraliService
  ) {
    
  }

  

  ngOnInit(): void {
    this.pratica = this.config.data.pratica;
    this.codiceInvioForm = this._formBuilder.group({
      nomeInvio: [this.pratica.codiceInvio, [Validators.required]],
     
    });
  }

  
  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      let praticaDaModificare: ModificaPraticaDTO = new ModificaPraticaDTO();
      praticaDaModificare.nomeInvio           = this.codiceInvioForm.value.nomeInvio;
      praticaDaModificare.codiceInvio         = this.codiceInvioForm.value.nomeInvio;
      praticaDaModificare.id                  = this.pratica.id;

      this.logger.info(praticaDaModificare);
      this.praticheScuolaService
            .modificaCodiceInvio(praticaDaModificare)
            .subscribe({
              next: (v) => {},
              error: (e) => {
                this.messageService.add({
                  severity: "info",
                 summary: "Errore" , life:10000,
                  detail: "Errore in fase di MODIFICA del codice INVIO della pratica",
                });
                this.dialogRef.close({ success: false });
              },
              complete: () => {
                this.dialogRef.close({ success: true });
              
              },
            });
    }
  }
}
